import type React from 'react';

export const DashboardsTab: React.FC = () => {
    return (
        <div className='flex flex-col gap-6 p-6'>
            <p>Not implemented.</p>
        </div>
    );
};
